"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CallSkeleton = _interopRequireDefault(require("../CallSkeleton"));
var _excluded = ["itemSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CallListSkeleton = function CallListSkeleton(_ref) {
  var _ref$itemSize = _ref.itemSize,
    itemSize = _ref$itemSize === void 0 ? 135 : _ref$itemSize,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    itemCount = _useState2[0],
    setItemCount = _useState2[1];
  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var wrapperSize = (0, _get2["default"])(wrapperRef.current, 'clientHeight') || 0;
    var newItemCount = Math.ceil(wrapperSize / itemSize);
    setItemCount(newItemCount);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(StyledCallSkeleton, (0, _extends2["default"])({
    ref: wrapperRef
  }, props), (0, _toConsumableArray2["default"])(Array(itemCount)).map(function () {
    return /*#__PURE__*/_react["default"].createElement(_CallSkeleton["default"], {
      height: itemSize
    });
  }));
};
var StyledCallSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "CallListSkeleton__StyledCallSkeleton",
  componentId: "sc-sffhwo-0"
})(["height:100%;"]);
var _default = exports["default"] = CallListSkeleton;